import React from 'react';
import { Component } from 'react';
import { Row, Container, Col, TabContent, TabPane, Nav, NavItem, NavLink, } from "reactstrap";
import classnames from 'classnames';
import RmDomesticListing from './RmDomesticListing';
import RmImportListing from './RmImportListing';
import RmSpecificationListing from './RmSpecificationListing';
import RmListing from './RmListing';



class RawMaterialMaster extends Component{

    state ={
        activeTab : "1"
    }

    /**
    * @method toggle
    * @description toggling the tabs
    */
     toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        return(
            <>
                <Container fluid>
                    <div className="app-wrap">
                        <Row>
                            <Col sm="4">
                                <h1>{`Raw Material Master`}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <Nav tabs className="subtabs mt-0">
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>Manage Raw Material (Domestic)</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); }}>Manage Raw Material (Import)</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => { this.toggle('3'); }}>Manage Specification</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames({ active: this.state.activeTab === '4' })} onClick={() => { this.toggle('4'); }}>Manage Material</NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                {this.state.activeTab == 1  && <TabPane tabId="1">
                                    <RmDomesticListing/>
                                </TabPane>}

                                {this.state.activeTab == 2  && <TabPane tabId="2">
                                    <RmImportListing/>
                                </TabPane>}
                                {this.state.activeTab == 3  && <TabPane tabId="3">
                                    <RmSpecificationListing/>
                                </TabPane>}
                                {this.state.activeTab == 4  && <TabPane tabId="4">
                                    <RmListing/>    
                                </TabPane>}
                            </TabContent>

                            </Col>
                        </Row>
                    </div>
                </Container>
            </>
        )
    }
}

export default RawMaterialMaster;